import { Component, inject, TemplateRef, ViewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SiAboutComponent } from '@siemens/element-ng/about';
import { SiModalService, ModalRef } from '@siemens/element-ng/modal';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Link } from '@siemens/element-ng/link';
import { LicenseInfo } from '@siemens/element-ng/about';
import { IFRAME_THEME_CSS } from './about-iframe-theme';

const MODAL_OPTIONS = { class: 'modal-xl', ignoreBackdropClick: false } as const;

@Component({
  selector: 'app-about',
  imports: [SiAboutComponent, TranslateModule],
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss',
  host: {
    class: 'si-layout-inner'
  }
})
export class AboutComponent {
  private readonly modalService = inject(SiModalService);
  private readonly sanitizer = inject(DomSanitizer);

  @ViewChild('readmeOssTpl') readmeOssTpl!: TemplateRef<any>;
  @ViewChild('legalTpl') legalTpl!: TemplateRef<any>;

  private modalRef?: ModalRef;

  readonly licenseInfo: LicenseInfo = { title: '' };
  readonly subheading: string[] = ['Version 0.9'];

  readonly imprintLink: Link = {
    title: 'Corporate information',
    action: () => this.openLegalModal('Corporate Information', this.corporateInformationUrl)
  };
  readonly privacyLink: Link = { title: 'Privacy policy', action: () => this.openLegalModal('Privacy Policy', this.privacyPolicyUrl) };
  readonly termsLink: Link = { title: 'Terms of use', action: () => this.openLegalModal('Terms of Use', this.termsOfUseUrl) };

  readonly readmeOssUrl: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
    'assets/readmeOSS.html'
  );
  readonly corporateInformationUrl: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
    'assets/corporateInformation.html'
  );
  readonly termsOfUseUrl: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
    'assets/termsOfUse.html'
  );
  readonly privacyPolicyUrl: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
    'assets/privacyPolicy.html'
  );

  legalModalTitle = '';
  legalModalUrl: SafeResourceUrl = this.termsOfUseUrl;

  readonly readmeOssLinks: Link[] = [
    {
      title: 'Readme OSS',
      action: () => this.openReadmeModal()
    }
  ];

  openReadmeModal(): void {
    this.modalRef = this.modalService.show(this.readmeOssTpl, MODAL_OPTIONS);
  }

  openLegalModal(title: string, url: SafeResourceUrl): void {
    this.legalModalTitle = title;
    this.legalModalUrl = url;
    this.modalRef = this.modalService.show(this.legalTpl, MODAL_OPTIONS);
  }

  closeReadmeModal(): void {
    this.modalRef?.hide();
  }

  onIframeLoad(iframe: HTMLIFrameElement): void {
    const iframeDoc = iframe.contentDocument;
    if (!iframeDoc) return;
    const style = iframeDoc.createElement('style');
    style.textContent = IFRAME_THEME_CSS;
    iframeDoc.head.appendChild(style);
  }
}
